export interface IAssignedTask {
    courtCaseNumber: string;
    dueDate: number | Date;
    typeId: number;
    typeName: string;
    tasksId: string;
    docId: string;
    hearingDate: null;
    courtLevel: null;
    caseCategory: string;
    cptId: null;
    cphId: number;
    taskDetails: string;
    categoryId: string;
    divisionId: number;
    styleClass: string;
    groupName?: string;
}

export interface IAssignedTaskEvent {
    name: ETaskScreenName | '';
    task: IAssignedTask;
    url: string;
}

export enum ETaskScreenName {
    COURTPANEL,
    HEARINGSCHEDULE,
    HEARINGPROCESS,
    DOCUMENTRECEPTION,
    FEEASSESSMENT,
    HEARINGNOTICE,
    RECORDFEEPAYMENT,
    JUDGEMENTSCHEDULE
}

export interface ITableConfig {
    column: string;
    styleClass?: string;
    label: string;
}

export interface ITableConfigExtended {
    id: number;
    column: string;
    styleClass?: string;
    label: string;
    items?: ITableConfig[];
}

export interface IMyAssignment {
    appealNumber: string;
    oldAppealNumber: string;
    suitNumber: string;
    appellant: string;
    respondent: string;
    hearingDate: number;
    timeCreated: string;
    caseCategory: string;
    divisionId: string;
    caseDivisionName: string;
    cphId: number;
    uniqueIdProperty: string;
    cutId: string;
    caseCourtUnitName: string;
    auditMessage: string;
    judgementDate?: number
}

export interface IMyAssignmentParams {
    page: number;
    start: number;
    limit: number;
    appealNumber?: string;
    caseNumber?: string;
}
export interface TaskConstants {
    tsktFeeAssessment: string;
    tsktFeePayment: string;
    tsktRipeforHearing: string;
    sctsktPrepareHearingSummons: string;
    coatsktPrepareHearingSummons: string;
    tsktAllocateCourtrooms: string;
    tsktHearing: string;
    tsktPrepareJudgement: string;
    tsktPrepareDraftdDrawnupOrder: string;
    tsktPrepareSignedDrawnupOrder: string;
    oathAffidavit: string;
    recordAppellantsBrief: string;
    tsktUploadAffidavitofService: string;
    coatsktUploadAffidavitofService: string;
    hctsktUploadAffidavitofService: string;
    tsktPrintorUploadOathSummons: string;
    coatsktPrintoruplOadoathSummons: string;
    hctsktPrintorUploadOathSummons: string;
    hctsktJudgeAssignment: string;
    tsktServiceofMotion: string;
    tsktMotionRipeforHearing: string;
    tsktServiceofAffidavit: string;
    hctsktPrepareMotionHearingNotice: string;
    hctsktUploadProofofserviceofMotionHearingNotice: string;
    tsktMotionHearing: string;
    tsktRuling: string;
    tsktCaseAssignment: string;
    tsktDraftEnrolledOrder: string;
    tsktSignedEnrolledOrder: string;
    tsktEfilingRequest: string;
    tsktFtmCaseRequest: string;
}

export interface TaskModel {
    isTaskCompleted: boolean;
    taskConstants: TaskConstants;
}
export interface Holiday {
    holidayDate: string;
    description: string;
    auditMessage: string;
}


